export enum ProductQueryUserInteractionType {
  browseTreeCategory = 'browse-tree-category',
  browseSupplier = 'browse-supplier',
  browseSupplierCategory = 'browse-supplier-category',
  browseStartPage = 'browse-start-page',
  search = 'search',
  similarProducts = 'similar-products'
}
